import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Automatically attach Customer Sanctum Bearer token to all requests if present in localStorage
window.axios.interceptors.request.use(
    (config) => {
        config.headers = config.headers || {};
        if (!config.headers.Authorization && !config.headers.authorization) {
            try {
                const token = typeof localStorage !== 'undefined' ? localStorage.getItem('customer_token') : null;
                if (token && token !== 'undefined' && token !== 'null') {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (_) {}
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Global 401 Unauthorized handling for customer tokens
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const url = error.config?.url || '';
            const isCustomerRoute = url.includes('/api/cart') || url.includes('/api/customer/');
            const isAuthRoute = url.includes('/verify-otp') || url.includes('/login') || url.includes('/register');

            if (isCustomerRoute && !isAuthRoute) {
                const hadAuth = !!(error.config?.headers?.Authorization || error.config?.headers?.authorization);
                if (hadAuth) {
                    try {
                        localStorage.removeItem('customer_token');
                        localStorage.removeItem('customer_data');
                        delete window.axios.defaults.headers.common['Authorization'];

                        if (typeof window !== 'undefined' && window.$publicStore) {
                            window.$publicStore.clearCustomer();
                        }
                    } catch (_) {}
                }
            }
        }
        return Promise.reject(error);
    }
);

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let _echoInstance = null;
let _echoInitAttempted = false;

function getOrCreateEcho() {
    if (_echoInitAttempted) return _echoInstance;
    _echoInitAttempted = true;

    const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;
    if (!reverbKey) return null;

    try {
        const isHttps = typeof window !== 'undefined' && window.location.protocol === 'https:';
        const reverbHost = import.meta.env.VITE_REVERB_HOST || (typeof window !== 'undefined' ? window.location.hostname : '');
        const reverbScheme = import.meta.env.VITE_REVERB_SCHEME || (isHttps ? 'https' : 'http');
        const reverbPort = import.meta.env.VITE_REVERB_PORT || (isHttps ? 443 : 8080);

        _echoInstance = new Echo({
            broadcaster: 'reverb',
            key: reverbKey,
            wsHost: reverbHost,
            wsPort: reverbPort,
            wssPort: reverbPort,
            forceTLS: reverbScheme === 'https',
            enabledTransports: ['ws', 'wss'],
        });

        // Prevent unhandled errors in console if WebSocket server is unreachable or offline
        if (_echoInstance?.connector?.pusher?.connection) {
            _echoInstance.connector.pusher.connection.bind('error', () => {});
            _echoInstance.connector.pusher.connection.bind('failed', () => {});
            _echoInstance.connector.pusher.connection.bind('unavailable', () => {});
        }
    } catch (e) {
        _echoInstance = null;
    }

    return _echoInstance;
}

if (typeof window !== 'undefined') {
    Object.defineProperty(window, 'Echo', {
        configurable: true,
        enumerable: true,
        get() {
            return getOrCreateEcho();
        },
        set(val) {
            _echoInstance = val;
        },
    });
}

